// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"fabb98f6","120":"887331cc"}[chunkId] + ".chunk.css";
};